// Angular
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

// Models
import { AppCleanup } from '../../models';

// Helpers
import { FormHelper } from '../../helpers';

@Component({
  selector: 'naming-dialog',
  templateUrl: './naming-dialog.component.html',
  styleUrls: ['./naming-dialog.component.scss'],
})
export class NamingDialogComponent extends AppCleanup implements OnInit, OnDestroy {
  title: string = 'Set name';
  label: string = 'Name';
  action: string = 'Save';
  existingValue: string;
  form: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<NamingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string; label: string; action: string; existingValue: string }
  ) {
    super();
  }

  ngOnInit() {
    if (this.data?.title) {
      this.title = this.data.title;
    }

    if (this.data?.label) {
      this.label = this.data.label;
    }

    if (this.data?.action) {
      this.action = this.data.action;
    }

    if (this.data?.existingValue) {
      this.existingValue = this.data.existingValue;
    }

    this.createForm();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  private createForm() {
    this.form = this.formBuilder.group({
      name: [this.existingValue ? this.existingValue : null, Validators.required],
    });
  }

  controlHasError(controlName: string, validationType: string): boolean {
    return FormHelper.controlHasError(this.form, controlName, validationType);
  }

  submit() {
    if (!this.form.dirty) return;

    const controls = this.form.controls;

    if (this.form.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      return;
    }

    this.dialogRef.close(controls.name?.value);
  }
}
